import fetcher from '@/utils/fetcher';
import { JsonWebTokenType } from '@/utils/token-manager';

/** 이메일 로그인 */
const postLoginByEmail = async (email: string, password: string) => {
  try {
    const res = await fetcher.post('/api/auth/login', {
      data: {
        type: 'email',
        email,
        password,
      },
    });
    return {
      data: res.data.data as JsonWebTokenType,
    };
  } catch (e: any) {
    const message = e.response?.data?.error?.message;
    const deletedAt = e.response?.data?.data?.deletedAt;
    if (message === 'incorrect password') {
      return { error: 'incorrect password' as const };
    }
    if (message === 'empty password') {
      return { error: 'empty password' as const };
    }
    if (message === 'too many failure') {
      return { error: 'too many failure' as const };
    }
    if (message === 'member is not enabled') {
      return { error: 'member is not enabled' as const };
    }
    if (message === 'member is pending deletion') {
      return {
        error: 'member is pending deletion' as const,
        deletedAt,
      };
    }
    return { error: 'internal server error' as const };
  }
};

export default postLoginByEmail;
